import { DesignData } from 'src/store/design/types';
import { Md5 } from 'md5-typescript';

// eslint-disable-next-line no-undef
export default (structure: DesignData) => Md5.init(structure);
